module.exports = __webpack_public_path__ + "img/eSupply.5ad22ae9.png";